// REGION: AUTH0 PARAMS

const EMAIL_FLOW = {
  link: "link",
  code: "code"
};

export { EMAIL_FLOW };
